"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var WeekNumber = /** @class */ (function (_super) {
    __extends(WeekNumber, _super);
    function WeekNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WeekNumber.prototype.render = function () {
        return (React.createElement("div", { className: "ee_react-datepicker__week-number", "aria-label": "week-" + this.props.weekNumber }, this.props.weekNumber));
    };
    WeekNumber.displayName = 'WeekNumber';
    WeekNumber.propTypes = {
        weekNumber: PropTypes.number.isRequired
    };
    return WeekNumber;
}(React.Component));
exports.WeekNumber = WeekNumber;
exports.default = WeekNumber;
//# sourceMappingURL=week_number.js.map